/**
 * Bibliothèque Problème métier → Template Expert.
 * Source : TaleScan V0.5, §4 et §6 (Univers/Domaines + Problèmes métier).
 * Volontairement statique : cette liste est censée rester "peu nombreuse et
 * stable" (V0.5 §12) — on migrera vers une source distante seulement si la
 * gouvernance des templates l'exige.
 */
export const taleScanDomains = {
  marketing: 'Marketing / Consumer Insights',
  rh: 'RH / Employee Insights',
  b2b: 'B2B / Business Insights',
  opinion: 'Opinion publique / Public Insights',
  innovation: 'Innovation',
  evaluation: 'Évaluation / Programmes / Projets',
  communication: 'Communication / Institutionnel',
};

export const taleScanProblems = [
  {
    problemId: 'buying',
    domainId: 'marketing',
    question: 'Pourquoi achète-t-on ou n\u2019achète-t-on pas ?',
    templateName: 'Buying',
    status: 'PUBLISHED',
    category: 'GENERAL_MARKET_RESEARCH',
    language: 'FRENCH',
  },
  {
    problemId: 'brand',
    domainId: 'marketing',
    question: 'Comment la marque est-elle perçue ?',
    templateName: 'Brand',
    status: 'DRAFT',
    category: 'BRAND_TRACKING_OR_AWARENESS',
    language: 'FRENCH',
  },
  {
    problemId: 'customer-experience',
    domainId: 'marketing',
    question: 'Comment l\u2019expérience client/consommateur est-elle vécue ?',
    templateName: 'Customer Experience',
    status: 'DRAFT',
  },
  {
    problemId: 'satisfaction',
    domainId: 'marketing',
    question: 'Dans quelle mesure les attentes sont-elles satisfaites ?',
    templateName: 'Satisfaction',
    status: 'DRAFT',
  },
  {
    problemId: 'usage',
    domainId: 'marketing',
    question: 'Comment, quand et pourquoi le produit/service est-il utilisé ?',
    templateName: 'Usage',
    status: 'DRAFT',
  },
  {
    problemId: 'loyalty',
    domainId: 'marketing',
    question: 'Pourquoi reste-t-on fidèle ou envisage-t-on de changer ?',
    templateName: 'Loyalty',
    status: 'DRAFT',
  },
  {
    problemId: 'price',
    domainId: 'marketing',
    question: 'Le prix est-il acceptable et cohérent avec la valeur perçue ?',
    templateName: 'Price',
    status: 'DRAFT',
  },
  {
    problemId: 'concept',
    domainId: 'marketing',
    question: 'Le concept répond-il à un besoin et présente-t-il un potentiel ?',
    templateName: 'Concept',
    status: 'DRAFT',
  },

  // RH / Employee
  { problemId: 'rh-employee-experience', domainId: 'rh', question: 'Comment l\u2019expérience employé est-elle vécue ?', templateName: 'Employee Experience', status: 'DRAFT' },
  { problemId: 'rh-engagement', domainId: 'rh', question: 'Dans quelle mesure les collaborateurs sont-ils engagés ?', templateName: 'Engagement', status: 'DRAFT' },
  { problemId: 'rh-employee-satisfaction', domainId: 'rh', question: 'Quel est le niveau de satisfaction ?', templateName: 'Employee Satisfaction', status: 'DRAFT' },
  { problemId: 'rh-motivation', domainId: 'rh', question: 'Qu\u2019est-ce qui motive ou démotive ?', templateName: 'Motivation', status: 'DRAFT' },
  { problemId: 'rh-onboarding', domainId: 'rh', question: 'Comment l\u2019intégration est-elle vécue ?', templateName: 'Onboarding', status: 'DRAFT' },
  { problemId: 'rh-training', domainId: 'rh', question: 'Quels besoins de formation et quelle valeur perçue ?', templateName: 'Training', status: 'DRAFT' },
  { problemId: 'rh-internal-communication', domainId: 'rh', question: 'La communication interne est-elle comprise et utile ?', templateName: 'Internal Communication', status: 'DRAFT' },
  { problemId: 'rh-retention', domainId: 'rh', question: 'Pourquoi rester ou partir ?', templateName: 'Retention', status: 'DRAFT' },

  // B2B / Business
  { problemId: 'b2b-needs', domainId: 'b2b', question: 'Quels besoins métiers sont insuffisamment couverts ?', templateName: 'B2B Needs', status: 'DRAFT' },
  { problemId: 'b2b-buying-process', domainId: 'b2b', question: 'Comment se déroule le processus d\u2019achat ?', templateName: 'Buying Process', status: 'DRAFT' },
  { problemId: 'b2b-decision-makers', domainId: 'b2b', question: 'Qui influence et décide ?', templateName: 'Decision Makers', status: 'DRAFT' },
  { problemId: 'b2b-supplier-selection', domainId: 'b2b', question: 'Quels critères déterminent le choix ?', templateName: 'Supplier Selection', status: 'DRAFT' },
  { problemId: 'b2b-customer-experience', domainId: 'b2b', question: 'Comment l\u2019expérience avec le fournisseur est-elle vécue ?', templateName: 'Customer Experience', status: 'DRAFT' },
  { problemId: 'b2b-satisfaction', domainId: 'b2b', question: 'Quel est le niveau de satisfaction ?', templateName: 'B2B Satisfaction', status: 'DRAFT' },
  { problemId: 'b2b-retention', domainId: 'b2b', question: 'Pourquoi le client reste ou change ?', templateName: 'Retention', status: 'DRAFT' },
  { problemId: 'b2b-value-proposition', domainId: 'b2b', question: 'Quelle valeur est réellement perçue ?', templateName: 'Value Proposition', status: 'DRAFT' },

  // Opinion publique / Public
  { problemId: 'opinion-opinion', domainId: 'opinion', question: 'Quelle est l\u2019opinion sur un sujet ?', templateName: 'Opinion', status: 'DRAFT' },
  { problemId: 'opinion-perception', domainId: 'opinion', question: 'Comment une institution/personne est-elle perçue ?', templateName: 'Perception', status: 'DRAFT' },
  { problemId: 'opinion-trust', domainId: 'opinion', question: 'Quel niveau de confiance ?', templateName: 'Trust', status: 'DRAFT' },
  { problemId: 'opinion-priorities', domainId: 'opinion', question: 'Quelles sont les priorités ?', templateName: 'Priorities', status: 'DRAFT' },
  { problemId: 'opinion-intentions', domainId: 'opinion', question: 'Quelles intentions peuvent être identifiées ?', templateName: 'Intentions', status: 'DRAFT' },
  { problemId: 'opinion-satisfaction', domainId: 'opinion', question: 'Quel est le niveau de satisfaction vis-à-vis d\u2019un service/action ?', templateName: 'Public Satisfaction', status: 'DRAFT' },
  { problemId: 'opinion-awareness', domainId: 'opinion', question: 'Quel est le niveau de connaissance ?', templateName: 'Awareness', status: 'DRAFT' },
  { problemId: 'opinion-acceptability', domainId: 'opinion', question: 'Dans quelle mesure une proposition est-elle acceptée ?', templateName: 'Acceptability / Support', status: 'DRAFT' },

  // Innovation
  { problemId: 'innovation-need-validation', domainId: 'innovation', question: 'Le besoin est-il réel et important ?', templateName: 'Need Validation', status: 'DRAFT' },
  { problemId: 'innovation-concept-evaluation', domainId: 'innovation', question: 'Le concept est-il compris et attractif ?', templateName: 'Concept Evaluation', status: 'DRAFT' },
  { problemId: 'innovation-adoption', domainId: 'innovation', question: 'Quels facteurs favorisent ou freinent l\u2019adoption ?', templateName: 'Adoption', status: 'DRAFT' },
  { problemId: 'innovation-barriers', domainId: 'innovation', question: 'Quels obstacles empêchent l\u2019adoption ?', templateName: 'Barriers', status: 'DRAFT' },
  { problemId: 'innovation-feature-prioritization', domainId: 'innovation', question: 'Quelles fonctionnalités sont prioritaires ?', templateName: 'Feature Prioritization', status: 'DRAFT' },
  { problemId: 'innovation-value-proposition', domainId: 'innovation', question: 'Quelle valeur est perçue ?', templateName: 'Value Proposition', status: 'DRAFT' },

  // Évaluation / Programmes / Projets
  { problemId: 'evaluation-needs-assessment', domainId: 'evaluation', question: 'Quels besoins sont prioritaires ?', templateName: 'Needs Assessment', status: 'DRAFT' },
  { problemId: 'evaluation-relevance', domainId: 'evaluation', question: 'Le programme répond-il aux besoins ?', templateName: 'Relevance', status: 'DRAFT' },
  { problemId: 'evaluation-satisfaction', domainId: 'evaluation', question: 'Quel est le niveau de satisfaction ?', templateName: 'Satisfaction', status: 'DRAFT' },
  { problemId: 'evaluation-beneficiary-experience', domainId: 'evaluation', question: 'Comment l\u2019expérience des bénéficiaires est-elle vécue ?', templateName: 'Beneficiary Experience', status: 'DRAFT' },
  { problemId: 'evaluation-effectiveness', domainId: 'evaluation', question: 'Les actions produisent-elles les effets attendus ?', templateName: 'Effectiveness', status: 'DRAFT' },
  { problemId: 'evaluation-accessibility', domainId: 'evaluation', question: 'Le service/programme est-il accessible ?', templateName: 'Accessibility', status: 'DRAFT' },
  { problemId: 'evaluation-impact-perception', domainId: 'evaluation', question: 'Quels effets sont perçus ?', templateName: 'Impact Perception', status: 'DRAFT' },
  { problemId: 'evaluation-improvement-priorities', domainId: 'evaluation', question: 'Quelles améliorations sont prioritaires ?', templateName: 'Improvement Priorities', status: 'DRAFT' },

  // Communication / Institutionnel
  { problemId: 'communication-message-testing', domainId: 'communication', question: 'Le message est-il compris, pertinent et crédible ?', templateName: 'Message Testing', status: 'DRAFT' },
  { problemId: 'communication-campaign-evaluation', domainId: 'communication', question: 'La campagne atteint-elle ses objectifs ?', templateName: 'Campaign Evaluation', status: 'DRAFT' },
  { problemId: 'communication-recall', domainId: 'communication', question: 'Que retient-on de la communication ?', templateName: 'Communication Recall', status: 'DRAFT' },
  { problemId: 'communication-channel-effectiveness', domainId: 'communication', question: 'Quels canaux sont pertinents ?', templateName: 'Channel Effectiveness', status: 'DRAFT' },
  { problemId: 'communication-credibility', domainId: 'communication', question: 'La communication est-elle crédible ?', templateName: 'Credibility', status: 'DRAFT' },
  { problemId: 'communication-engagement', domainId: 'communication', question: 'Quels contenus suscitent l\u2019intérêt ?', templateName: 'Engagement', status: 'DRAFT' },
];

export const getProblemById = (problemId) =>
    taleScanProblems.find((p) => p.problemId === problemId) ?? null;

/**
 * Banque de questions core par problème métier, avec type de réponse et
 * options — prête à être mappée sur le payload de création de survey réel
 * une fois ce mapping connu (cf. handleSelect dans TaleScanDashboard.jsx).
 *
 * BUYING : source Tale_Scan_AI_TaleCraft Specification §9.
 * BRAND  : source Modèle_Brand_Perception.docx fourni par le client
 *          (jeu de questions n°2 du document, celui avec un "Type : ..."
 *          explicite sur chaque question — l'autre jeu du même doc n'a pas
 *          de type annoté). À confirmer avec le client si ce n'était pas
 *          le jeu voulu.
 * Tout le reste de la bibliothèque n'a pas encore de contenu réel — un
 * template DRAFT sans banque ici démarre une survey sans questions
 * pré-remplies plutôt que de planter.
 */
const CORE_QUESTIONS_BY_PROBLEM = {
  buying: [
    { text: 'À quelle fréquence achetez-vous {product} ?', responseType: 'single_choice' },
    { text: 'Quels critères influencent votre choix de {product} ?', responseType: 'multiple_choice' },
    { text: 'Quelles marques de {product} achetez-vous habituellement ?', responseType: 'multiple_choice' },
    { text: 'Quelle est la principale raison de choisir une marque de {product} ?', responseType: 'single_choice' },
    { text: 'Qu\u2019est-ce qui peut vous empêcher d\u2019acheter cette marque ?', responseType: 'multiple_choice' },
    { text: 'Comment percevez-vous son niveau de prix ?', responseType: 'scale' },
    { text: 'Quelle est votre intention d\u2019achat ?', responseType: 'scale' },
    { text: 'Qu\u2019est-ce qui pourrait vous convaincre ?', responseType: 'multiple_choice' },
  ],
  brand: [
    {
      // Q1
      text: 'Connaissiez-vous {product} avant ce sondage ?',
      responseType: 'single_choice',
      options: [
        'Je la connais bien et je l\u2019utilise',
        'Je la connais mais je ne l\u2019utilise pas',
        'J\u2019en ai entendu parler, sans plus',
        'Je ne la connaissais pas avant ce sondage',
      ],
    },
    // Q2 — type "matrice" dans le doc client (4 lignes, échelle 1-5 partagée) :
    // pas de format "matrice" dans l'app, éclaté en 4 questions star (1-5)
    // séparées, description = les deux pôles de l'axe. À revoir si un vrai
    // type matrice existe côté backend.
    {
      text: 'Comment situez-vous {product} sur l\u2019axe : Traditionnelle (1) \u2192 Moderne (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l\u2019axe : Peu fiable (1) \u2192 Fiable (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l\u2019axe : Distante (1) \u2192 Proche des gens (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l\u2019axe : Peu innovante (1) \u2192 Innovante (5) ?',
      responseType: 'rating_1_5',
    },
    {
      // Q3
      text: 'Dans quelle mesure {product} vous paraît-elle différente de ses concurrents ?',
      responseType: 'single_choice',
      options: [
        'Très différente', 'Assez différente', 'Moyennement différente',
        'Peu différente', 'Pas du tout différente',
        'Je ne connais pas assez les autres marques pour comparer',
      ],
    },
    {
      // Q4 — réaction instinctive par émojis
      text: 'Quelle est votre réaction instinctive en pensant à {product} ?',
      responseType: 'emoji_scale',
    },
    {
      // Q5
      text: 'Selon vous, quelle est la principale force de {product} ?',
      responseType: 'single_choice_other',
      options: [
        'La qualité de ses produits/services', 'Son prix ou son rapport qualité-prix',
        'Son service client ou son accompagnement', 'Sa réputation ou la confiance qu\u2019elle inspire',
        'Sa proximité ou son accessibilité', 'Autre',
      ],
    },
    {
      // Q6 révisée
      text: 'Si vous deviez résumer {product} en une seule expression, laquelle choisiriez-vous ?',
      responseType: 'single_choice',
      options: [
        'Une marque de confiance', 'Une marque innovante', 'Une marque accessible',
        'Une marque haut de gamme', 'Une marque proche des gens',
        'Une marque comme une autre, sans particularité',
      ],
    },
    {
      // Q7
      text: 'Sur une échelle de 0 à 10, quelle est la probabilité que vous recommandiez {product} à un proche ?',
      responseType: 'scale',
    },
    {
      // Q8
      text: 'Si vous pouviez changer ou améliorer une seule chose concernant {product}, laquelle serait-ce ?',
      responseType: 'open_text',
    },
  ],
};

const contextualize = (question, context) => ({
  ...question,
  text: question.text.replace('{product}', context?.product?.trim() || 'ce produit/service'),
});

/**
 * Renvoie la banque de questions core pour un problème, contextualisée.
 * Synchrone (plus de mock avec délai — la vraie création de survey portera
 * l'asynchronicité côté API). Renvoie [] si le template n'a pas encore de
 * contenu réel, pour démarrer une survey vide plutôt que planter.
 */
export const getCoreQuestions = (problemId, context = {}) => {
  const bank = CORE_QUESTIONS_BY_PROBLEM[problemId] ?? [];
  return bank.map((q) => contextualize(q, context));
};

/**
 * Maps our template question shape onto the real survey question shape
 * consumed by CreateSurveyLayout / CreateSurveyStep2 (question_text,
 * format, possible_responses, responseType — see isQuestionGood in
 * survey/new/scratch/index.jsx).
 *
 * format enum: "1-10" | "smile" | "star" | "comment" | "checkbox" | "radio"
 * responseType here means question MEDIA type (TEXT/IMAGE/VIDEO/SOUND),
 * not the answer type — always TEXT for TaleScan-generated questions.
 *
 * IMPORTANT: Buying's single_choice/multiple_choice questions don't have
 * real option text yet (the client's Buying doc only gave the question
 * title, no answer list — cf. taleScanProblems.js note above). Rather than
 * invent plausible-sounding options, those fall back to "comment" (open
 * text) until real options exist — flagged, not silently guessed.
 */
const RESPONSE_TYPE_TO_FORMAT = {
  single_choice: 'radio',
  multiple_choice: 'checkbox',
  single_choice_other: 'radio',
  rating_1_5: 'star',
  scale: '1-10',
  emoji_scale: 'smile',
  open_text: 'comment',
};

export const toSurveyQuestion = (question) => {
  const needsOptions = ['radio', 'checkbox'].includes(RESPONSE_TYPE_TO_FORMAT[question.responseType]);
  const hasOptions = Array.isArray(question.options) && question.options.length > 0;
  const format = needsOptions && !hasOptions ? 'comment' : RESPONSE_TYPE_TO_FORMAT[question.responseType] ?? 'comment';

  return {
    id: crypto.randomUUID(),
    question_text: question.text,
    format,
    responseType: 'TEXT',
    possible_responses: format === 'radio' || format === 'checkbox' ? question.options : [],
    assets: [],
  };
};